import { userInfo } from 'os';
import React from 'react';
import { useState } from 'react';
import { FC, useRef } from 'react'
interface User {
    id: string;
    name: string;
    productionIds: number[];
    registryId: string
    // Add other user properties as needed
}

interface ProductionReceiptProps {
    user: any;
    // user: User;
}


const lineStyle = {
    marginTop: '1px',
    borderTop: '1px solid #000', // Adjust the color and width as needed
}

const ProductionReceipt1: React.FC<ProductionReceiptProps> = ({ user }) => {





    return (
        <>

            <div className="print-container" style={{ maxWidth: '64rem', margin: '0 auto', padding: '1.5rem', backgroundColor: 'white' }}

            >








                <img
                    src="/BGImg.png"
                    alt="background"
                    style={{
                        position: 'absolute',
                        top: '-1.5rem',          // Offset by negative padding
                        left: '-1.5rem',         // Offset by negative padding  
                        width: 'calc(100% + 3rem)',  // Add padding back
                        height: 'calc(100% + 3rem)', // Add padding back
                        objectFit: 'cover',
                        opacity: 0,
                        zIndex: -1,
                        pointerEvents: 'none',
                    }}
                />






                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h1
                        style={{
                            fontSize: '32px',
                            fontStyle: 'italic',
                            fontWeight: 'bold',
                            lineHeight: '40px',
                            // padding: '21px 40px',
                            margin: 0,
                        }}
                    >
                        Registry Document
                    </h1>
                    <img
                        style={{
                            backgroundColor: 'rgb(255, 255, 255)',
                            marginTop: '1px',
                            width: '150px',        // Add width
                            height: '150px',       // Add height
                            objectFit: 'contain'  // Maintain aspect ratio
                        }}
                        src="/BGImgl.png"
                        alt="main-logo"
                    />
                </div>




                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                    marginBottom: '1rem'
                }}>
                    {/* Left side - Registry info */}
                    <div>
                        <div style={{ fontSize: "1.075rem", marginBottom: '0.5rem' }}>
                            <span style={{ fontSize: "1.075rem", fontWeight: '500', color: 'black' }}>Registry No : </span>
                            <span style={{ fontSize: "1.075rem", color: '#2563eb' }}>{user.registryId}</span>
                        </div>
                        <div style={{ fontSize: "1.075rem", marginBottom: '0.5rem' }}>
                            <span style={{ fontSize: "1.075rem", fontWeight: '500', color: 'black' }}>Document No : </span>
                            <span style={{ fontSize: "1.075rem", color: '#2563eb' }}></span>
                        </div>
                        <div style={{ fontSize: "1.075rem" }}>
                            <span style={{ fontSize: "1.075rem", fontWeight: '500', color: 'black' }}>Date : </span>
                            <span style={{ fontSize: "1.075rem", color: '#2563eb' }}>2025-06-23</span>
                        </div>
                    </div>

                    {/* Right side - Image */}
                    <div style={{
                        width: '9rem',
                        height: '9rem',
                        border: '1px solid #d1d5db',
                        borderRadius: '50%',  // Changed from '0.25rem' to '50%' for round shape
                        overflow: 'hidden',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <img
                            src={user?.kycDocuments?.docUrl}
                            alt="KYC Document"
                            style={{
                                width: '150%',
                                height: '150%',
                                objectFit: 'cover'
                            }}
                        />
                    </div>
                </div>




                <div style={{ marginBottom: '1.5rem', marginTop: "20px", }}>




                    <h2 style={{ fontSize: '1.125rem', fontWeight: 'bold', marginBottom: '0.75rem', color: 'black' }}>Facility information</h2>
                    <div style={{ marginTop: '-10px', borderTop: '1px solid #000' }}></div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(12, 1fr)', gap: '1rem', fontSize: "1.075rem" }}>
                        <div style={{ gridColumn: 'span 8' }}>
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '0.5rem', fontSize: '0.875rem' }}>
                                <div style={{ fontWeight: '500', color: 'black', fontSize: "1.075rem" }}>Business name</div>
                                <div style={{ gridColumn: 'span 2', color: 'black', fontSize: "1.075rem" }}>: {user?.pickupPointInfo?.name}</div>
                                <div style={{ fontWeight: '500', color: 'black', fontSize: "1.075rem" }}>Address</div>
                                <div style={{ gridColumn: 'span 2', color: 'black', fontSize: "1.075rem" }}>: {user?.pickupPointInfo?.address?.street}</div>
                                <div style={{ fontWeight: '500', color: 'black', fontSize: "1.075rem" }}>Location</div>
                                <div style={{ gridColumn: 'span 2', color: 'black', fontSize: "1.075rem" }}>: {user?.pickupPointInfo?.address?.latitute},{user?.pickupPointInfo?.address?.longitute}</div>
                            </div>
                        </div>


                    </div>
                </div>



                {/* Process name */}
                <div style={{ marginBottom: '1.5rem' }}>




                    <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #d1d5db', marginBottom: '1rem', backgroundColor: '#ffffff' }}>

                        <thead>
                            <tr style={{ backgroundColor: '#e6f7f7' }}>
                                <th style={{ border: '1px solid #d1d5db', padding: '0.75rem', textAlign: 'left', fontSize: "1.075rem", fontWeight: 'bold', color: '#447a7d', backgroundColor: '#e6f7f7' }}>SL</th>
                                <th style={{ border: '1px solid #d1d5db', padding: '0.75rem', textAlign: 'left', fontSize: "1.075rem", fontWeight: 'bold', color: '#447a7d', backgroundColor: '#e6f7f7' }}>Type</th>
                                <th style={{ border: '1px solid #d1d5db', padding: '0.75rem', textAlign: 'left', fontSize: "1.075rem", fontWeight: 'bold', color: '#447a7d', backgroundColor: '#e6f7f7' }}>Category</th>
                                <th style={{ border: '1px solid #d1d5db', padding: '0.75rem', textAlign: 'left', fontSize: "1.075rem", fontWeight: 'bold', color: '#447a7d', backgroundColor: '#e6f7f7' }}>Item</th>
                                <th style={{ border: '1px solid #d1d5db', padding: '0.75rem', textAlign: 'left', fontSize: "1.075rem", fontWeight: 'bold', color: '#447a7d', backgroundColor: '#e6f7f7' }}>Quantity</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr>
                                <td style={{ border: '1px solid #d1d5db', padding: '0.75rem', fontSize: "1.075rem", color: 'black' }}>1</td>
                                <td style={{ border: '1px solid #d1d5db', padding: '0.75rem', fontSize: "1.075rem", color: 'black' }}>Output Material</td>
                                <td style={{ border: '1px solid #d1d5db', padding: '0.75rem', fontSize: "1.075rem", color: 'black' }}>
                                    {user?.productionItemDetails?.[0]?.categoryName}
                                </td>
                                <td style={{
                                    border: '1px solid #d1d5db', padding: '0.75rem', fontSize: "1.075rem", color: 'black'
                                }}>{user?.productionItemDetails?.[0]?.itemName}</td>
                                <td style={{ border: '1px solid #d1d5db', padding: '0.75rem', fontSize: "1.075rem", color: 'black' }}>
                                    {user?.productionItemDetails?.[0]?.quantity
                                        ? Number(user.productionItemDetails[0].quantity).toFixed(2)
                                        : '0.00'} kg</td>
                            </tr>

                            {user?.inputMaterial?.map((material, index) => (
                                <tr key={index}>
                                    <td style={{ border: '1px solid #d1d5db', padding: '0.75rem', fontSize: "1.075rem", color: 'black' }}>
                                        {index + 2}
                                    </td>
                                    <td style={{ border: '1px solid #d1d5db', padding: '0.75rem', fontSize: "1.075rem", color: 'black' }}>
                                        Input Material
                                    </td>
                                    <td style={{ border: '1px solid #d1d5db', padding: '0.75rem', fontSize: "1.075rem", color: 'black' }}>
                                        {material.inputMaterialCategoryName}
                                    </td>
                                    <td style={{ border: '1px solid #d1d5db', padding: '0.75rem', fontSize: "1.075rem", color: 'black' }}>
                                        {material.inputMaterialName}
                                    </td>
                                    <td style={{ border: '1px solid #d1d5db', padding: '0.75rem', fontSize: "1.075rem", color: 'black' }}>
                                        {material.inputQuantity
                                            ? Number(material.inputQuantity).toFixed(2)
                                            : '0.00'} kg
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>


                </div>

                {/* Production information */}
                <div style={{ marginBottom: '1.5rem' }}>
                    <h2 style={{ fontSize: '1.125rem', fontWeight: 'bold', marginBottom: '0.75rem', color: 'black' }}>Production information</h2>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(12, 1fr)', gap: '1rem' }}>
                        <div style={{ gridColumn: 'span 8' }}>
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '0.5rem', fontSize: '0.875rem' }}>
                                <div style={{ fontWeight: '500', color: 'black', fontSize: "1.075rem" }}>Date</div>
                                <div style={{ gridColumn: 'span 2', color: 'black', fontSize: "1.075rem" }}>: 6/23/2025</div>


                                <div style={{ fontWeight: '500', color: 'black', fontSize: "1.075rem" }}>Process name</div>
                                <div style={{ gridColumn: 'span 2', color: 'black', fontSize: "1.075rem" }}>:
                                    {user?.processName}
                                </div>


                                <div style={{ fontWeight: '500', color: 'black', fontSize: "1.075rem" }}>Chain of custody</div>
                                <div style={{ gridColumn: 'span 2', color: 'black', fontSize: "1.075rem" }}>: Batch traceability</div>

                                <div style={{ fontWeight: '500', color: 'black', fontSize: "1.075rem" }}>Methodology</div>
                                <div style={{ gridColumn: 'span 2', color: 'black', fontSize: "1.075rem" }}>: ISO 22095 [Mass balance]</div>
                            </div>
                        </div>
                        <div style={{ gridColumn: 'span 4', textAlign: 'center' }}>
                            <div style={{ fontWeight: 'bold', fontSize: '1.125rem', marginBottom: '0.5rem', color: 'black' }}>Akbar</div>
                            <div style={{ fontWeight: '500', color: 'black' }}>Signature</div>
                        </div>
                    </div>
                </div>










                <div className="print-sections" style={{
                    display: 'block',
                    width: '100%',
                    position: 'relative',
                    zIndex: 1
                }}>


                    <div style={{
                        border: '1px solid #e0e0e0',
                        borderRadius: '8px',
                        backgroundColor: 'white',
                        boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                        overflow: 'hidden',
                        marginBottom: "20px"
                    }}>
                        {/* Header */}
                        <div style={{
                            backgroundColor: '#e6f7f7',
                            padding: '12px 20px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            borderBottom: '1px solid #e0e0e0'
                        }}>
                            <h3 style={{
                                margin: 0,
                                fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                fontSize: '16px',
                                fontWeight: '600',
                                color: '#007a7d'
                            }}>
                                Certifications Details
                            </h3>
                            <div style={{
                                width: '20px',
                                height: '20px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '14px',
                                fontWeight: 'bold',
                                transition: 'transform 0.3s ease',
                                color: '#007a7d'
                            }}>
                                ▼
                            </div>
                        </div>

                        {/* Content area */}
                        <div style={{ padding: '20px' }}>
                            {/* Flexible field container */}
                            <div style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: '20px',
                                marginBottom: '20px'
                            }}>
                                {/* Certification Name */}
                                <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                    <div style={{
                                        margin: 0,
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        fontSize: '1rem',
                                        fontWeight: 400,
                                        letterSpacing: 0,
                                        lineHeight: '22px',
                                        color: '#282828',
                                        marginBottom: '8px'
                                    }}>
                                        Name
                                    </div>
                                    <div style={{
                                        backgroundColor: '#f8f8f8',
                                        borderRadius: "2px",
                                        padding: '6px 12px',
                                        display: 'inline-block',
                                        minWidth: '80px',
                                        fontWeight: "bold"
                                    }}>
                                        <span style={{
                                            fontSize: '13px',
                                            color: '#333',
                                            fontWeight: 'bold',
                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                        }}>
                                            {user?.user?.[0]?.certifications?.[0]?.certificationName || 'N/A'}
                                        </span>
                                    </div>
                                </div>

                                {/* Authority */}
                                <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                    <div style={{
                                        margin: 0,
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        fontSize: '1rem',
                                        fontWeight: 400,
                                        letterSpacing: 0,
                                        lineHeight: '22px',
                                        color: '#282828',
                                        marginBottom: '8px'
                                    }}>
                                        Authority
                                    </div>
                                    <div style={{
                                        backgroundColor: '#f8f8f8',
                                        borderRadius: "2px",
                                        padding: '6px 12px',
                                        display: 'inline-block',
                                        minWidth: '80px',
                                        fontWeight: "bold",
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                    }}>
                                        <span style={{
                                            fontSize: '13px',
                                            // color: '#2563eb',
                                            fontWeight: 'bold',
                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                        }}>
                                            {user?.user?.[0]?.certifications?.[0]?.issuingAuthorities || 'N/A'}
                                        </span>
                                    </div>
                                </div>

                                {/* Certification Number */}
                                <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                    <div style={{
                                        margin: 0,
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        fontSize: '1rem',
                                        fontWeight: 400,
                                        letterSpacing: 0,
                                        lineHeight: '22px',
                                        color: '#282828',
                                        marginBottom: '8px'
                                    }}>
                                        Number
                                    </div>
                                    <div style={{
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        backgroundColor: '#f8f8f8',
                                        borderRadius: "2px",
                                        padding: '6px 12px',
                                        display: 'inline-block',
                                        minWidth: '80px',
                                        fontWeight: "bold"
                                    }}>
                                        <span style={{
                                            fontSize: '13px',
                                            color: '#333',
                                            fontWeight: 'bold',
                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                        }}>
                                            {user?.user?.[0]?.certifications?.[0]?.certificationNo || 'N/A'}
                                        </span>
                                    </div>
                                </div>

                                {/* Valid till */}
                                <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                    <div style={{
                                        margin: 0,
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        fontSize: '1rem',
                                        fontWeight: 400,
                                        letterSpacing: 0,
                                        lineHeight: '22px',
                                        color: '#282828',
                                        marginBottom: '8px'
                                    }}>
                                        Valid till
                                    </div>
                                    <div style={{
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        backgroundColor: '#f8f8f8',
                                        borderRadius: "2px",
                                        padding: '6px 12px',
                                        display: 'inline-block',
                                        minWidth: '80px',
                                        fontWeight: "bold"
                                    }}>
                                        <span style={{
                                            fontSize: '13px',
                                            color: '#333',
                                            fontWeight: "bold",
                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                        }}>
                                            {user?.user?.[0]?.certifications?.[0]?.validTill?.split('T')[0] || 'N/A'}
                                        </span>
                                    </div>
                                </div>



                                {/* Add this after the Valid till field in the Certifications Details */}
                                <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                    <div style={{
                                        margin: 0,
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        fontSize: '1rem',
                                        fontWeight: 400,
                                        letterSpacing: 0,
                                        lineHeight: '22px',
                                        color: '#282828',
                                        marginBottom: '8px'
                                    }}>
                                        Logo
                                    </div>
                                    <div style={{
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        // backgroundColor: '#f8f8f8',
                                        borderRadius: "2px",
                                        padding: '6px 12px',
                                        display: 'inline-block',
                                        minWidth: '80px',
                                        fontWeight: "bold"
                                    }}>
                                        <img
                                            src={user?.user?.[0]?.certifications?.[0]?.logo}
                                            alt={user?.user?.[0]?.certifications?.[0]?.certificationName}
                                            style={{
                                                width: '40px',
                                                height: '40px',
                                                borderRadius: '50%',
                                                objectFit: 'cover',
                                                border: '2px solid #e5e7eb',
                                                cursor: 'pointer'  // Add cursor pointer
                                            }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                window.open(user?.user?.[0]?.certifications?.[0]?.logo, '_blank');
                                            }}
                                        />
                                    </div>
                                </div>

                            </div>

                            {/* Multiple Certifications Support */}
                            {user?.user?.[0]?.certifications?.length > 1 && (
                                <div>
                                    <h4 style={{ fontSize: '12px', fontWeight: '600', color: '#333', marginBottom: '10px' }}>
                                        Additional Certifications
                                    </h4>
                                    {user?.user?.[0].certifications.slice(1).map((cert, index) => (
                                        <div key={index} style={{
                                            display: 'flex',
                                            flexWrap: 'wrap',
                                            gap: '20px',
                                            marginBottom: '15px',
                                            padding: '10px',
                                            backgroundColor: '#f9f9f9',
                                            borderRadius: '4px'
                                        }}>
                                            <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                                <div style={{
                                                    fontSize: '12px',
                                                    color: '#666',
                                                    marginBottom: '4px'
                                                }}>
                                                    Name
                                                </div>
                                                <div style={{
                                                    fontSize: '13px',
                                                    fontWeight: 'bold',
                                                    color: '#333'
                                                }}>
                                                    {cert.certificationName || 'N/A'}
                                                </div>
                                            </div>
                                            <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                                <div style={{
                                                    fontSize: '12px',
                                                    color: '#666',
                                                    marginBottom: '4px'
                                                }}>
                                                    Authority
                                                </div>
                                                <div style={{
                                                    fontSize: '13px',
                                                    fontWeight: 'bold',
                                                    color: '#2563eb'
                                                }}>
                                                    {cert.issuingAuthorities || 'N/A'}
                                                </div>
                                            </div>
                                            <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                                <div style={{
                                                    fontSize: '12px',
                                                    color: '#666',
                                                    marginBottom: '4px'
                                                }}>
                                                    Number
                                                </div>
                                                <div style={{
                                                    fontSize: '13px',
                                                    fontWeight: 'bold',
                                                    color: '#333'
                                                }}>
                                                    {cert.certificationNo || 'N/A'}
                                                </div>
                                            </div>
                                            <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                                <div style={{
                                                    fontSize: '12px',
                                                    color: '#666',
                                                    marginBottom: '4px'
                                                }}>
                                                    Valid till
                                                </div>
                                                <div style={{
                                                    fontSize: '13px',
                                                    fontWeight: 'bold',
                                                    color: '#333'
                                                }}>
                                                    {cert.validTill?.split('T')[0] || 'N/A'}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>




                    <div style={{
                        border: '1px solid #e0e0e0',
                        borderRadius: '8px',
                        backgroundColor: 'white',
                        boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                        overflow: 'hidden',
                        marginBottom: "20px"
                    }}>
                        {/* Header */}
                        <div style={{
                            backgroundColor: '#e6f7f7',
                            padding: '12px 20px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            borderBottom: '1px solid #e0e0e0'
                        }}>
                            <h3 style={{
                                margin: 0,
                                fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                fontSize: '16px',
                                fontWeight: '600',
                                color: '#007a7d'
                            }}>
                                KYC documents
                            </h3>
                            <div style={{
                                width: '20px',
                                height: '20px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '14px',
                                fontWeight: 'bold',
                                transition: 'transform 0.3s ease',
                                color: '#007a7d'
                            }}>
                                ▼
                            </div>
                        </div>

                        {/* Content area */}
                        <div style={{ padding: '20px' }}>
                            {/* Flexible field container */}
                            <div style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: '40px',
                                marginBottom: '20px'
                            }}>
                                {/* Business registration Section */}
                                <div style={{ flex: '0 0 auto', minWidth: '250px' }}>
                                    <h4 style={{
                                        margin: 0,
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        fontSize: '14px',
                                        fontWeight: '600',
                                        color: '#007a7d',
                                        marginBottom: '15px'
                                    }}>
                                        Business registration
                                    </h4>

                                    {/* Document number */}
                                    <div style={{ marginBottom: '10px' }}>
                                        <div style={{
                                            margin: 0,
                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                            fontSize: '1rem',
                                            fontWeight: 400,
                                            letterSpacing: 0,
                                            lineHeight: '22px',
                                            color: '#282828',
                                            marginBottom: '8px'
                                        }}>
                                            {/* Document number */}
                                        </div>
                                        <div style={{
                                            backgroundColor: '#f8f8f8',
                                            borderRadius: "2px",
                                            padding: '6px 12px',
                                            display: 'inline-block',
                                            minWidth: '80px',
                                            fontWeight: "bold"
                                        }}>
                                            <span style={{
                                                fontSize: '13px',
                                                color: '#333',
                                                fontWeight: 'bold',
                                                fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                            }}>
                                                {user?.pickupPointInfo?.kycDocument?.find(doc => doc.docType === "POE")?.docNumber || 'N/A'}
                                            </span>
                                        </div>
                                    </div>

                                    {/* Image */}
                                    <div>
                                        <div style={{
                                            margin: 0,
                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                            fontSize: '1rem',
                                            fontWeight: 400,
                                            letterSpacing: 0,
                                            lineHeight: '22px',
                                            color: '#282828',
                                            marginBottom: '8px'
                                        }}>
                                            {/* Document */}
                                        </div>
                                        <div style={{
                                            width: '100px',
                                            height: '100px',
                                            border: '1px solid #ddd',
                                            borderRadius: '6px',
                                            overflow: 'hidden'
                                        }}>
                                            <img
                                                src={user?.pickupPointInfo?.kycDocument?.find(doc => doc.docType === "POE")?.docUrl}
                                                alt="Business registration"
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover',
                                                    cursor: 'pointer'
                                                }}
                                                onClick={() => {
                                                    const poeDoc = user?.pickupPointInfo?.kycDocument?.find(doc => doc.docType === "POE");
                                                    if (poeDoc?.docUrl) {
                                                        window.open(poeDoc.docUrl, '_blank');
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* Environment Permit Section */}
                                <div style={{ flex: '0 0 auto', minWidth: '250px' }}>
                                    <h4 style={{
                                        margin: 0,
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        fontSize: '14px',
                                        fontWeight: '600',
                                        color: '#007a7d',
                                        marginBottom: '15px'
                                    }}>
                                        Environment Permit
                                    </h4>

                                    {/* Document number */}
                                    <div style={{ marginBottom: '10px' }}>
                                        <div style={{
                                            margin: 0,
                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                            fontSize: '1rem',
                                            fontWeight: 400,
                                            letterSpacing: 0,
                                            lineHeight: '22px',
                                            color: '#282828',
                                            marginBottom: '8px'
                                        }}>
                                            {/* Document number */}
                                        </div>
                                        <div style={{
                                            backgroundColor: '#f8f8f8',
                                            borderRadius: "2px",
                                            padding: '6px 12px',
                                            display: 'inline-block',
                                            minWidth: '80px',
                                            fontWeight: "bold"
                                        }}>
                                            <span style={{
                                                fontSize: '13px',
                                                color: '#333',
                                                fontWeight: 'bold',
                                                fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                            }}>
                                                {user?.pickupPointInfo?.kycDocument?.find(doc => doc.docType === "POI")?.docNumber || 'N/A'}
                                            </span>
                                        </div>
                                    </div>

                                    {/* Image */}
                                    <div>
                                        <div style={{
                                            margin: 0,
                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                            fontSize: '1rem',
                                            fontWeight: 400,
                                            letterSpacing: 0,
                                            lineHeight: '22px',
                                            color: '#282828',
                                            marginBottom: '8px'
                                        }}>
                                            {/* Document */}
                                        </div>
                                        <div style={{
                                            width: '100px',
                                            height: '100px',
                                            border: '1px solid #ddd',
                                            borderRadius: '6px',
                                            overflow: 'hidden'
                                        }}>
                                            <img
                                                src={user?.pickupPointInfo?.kycDocument?.find(doc => doc.docType === "POI")?.docUrl}
                                                alt="Environment Permit"
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover',
                                                    cursor: 'pointer'
                                                }}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    const poiDoc = user?.pickupPointInfo?.kycDocument?.find(doc => doc.docType === "POI");
                                                    if (poiDoc?.docUrl) {
                                                        window.open(poiDoc.docUrl, '_blank');
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>



                    <div style={{
                        border: '1px solid #e0e0e0',
                        borderRadius: '8px',
                        backgroundColor: 'white',
                        boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                        overflow: 'hidden',
                        marginBottom: "20px"
                    }}>
                        {/* Header */}
                        <div style={{
                            backgroundColor: '#e6f7f7',
                            padding: '12px 20px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            borderBottom: '1px solid #e0e0e0'
                        }}>
                            <h3 style={{
                                margin: 0,
                                fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                fontSize: '16px',
                                fontWeight: '600',
                                color: '#007a7d'
                            }}>
                                Sponsor Details
                            </h3>
                            <div style={{
                                width: '20px',
                                height: '20px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '14px',
                                fontWeight: 'bold',
                                transition: 'transform 0.3s ease',
                                color: '#007a7d'
                            }}>
                                ▼
                            </div>
                        </div>

                        {/* Content area */}
                        <div style={{ padding: '20px' }}>
                            {/* Flexible field container */}
                            <div style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: '20px',
                                marginBottom: '20px'
                            }}>
                                {/* Sponsor Name */}
                                <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                    <div style={{
                                        margin: 0,
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        fontSize: '1rem',
                                        fontWeight: 400,
                                        letterSpacing: 0,
                                        lineHeight: '22px',
                                        color: '#282828',
                                        marginBottom: '8px'
                                    }}>
                                        Name
                                    </div>
                                    <div style={{
                                        backgroundColor: '#f8f8f8',
                                        borderRadius: "2px",
                                        padding: '6px 12px',
                                        display: 'inline-block',
                                        minWidth: '80px',
                                        fontWeight: "bold"
                                    }}>
                                        <span style={{
                                            fontSize: '13px',
                                            color: '#333',
                                            fontWeight: 'bold',
                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                        }}>
                                            {user?.user?.[0]?.sponsorDetails?.[0]?.sponsorName || 'N/A'}
                                        </span>
                                    </div>
                                </div>

                                {/* Quantity */}
                                <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                    <div style={{
                                        margin: 0,
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        fontSize: '1rem',
                                        fontWeight: 400,
                                        letterSpacing: 0,
                                        lineHeight: '22px',
                                        color: '#282828',
                                        marginBottom: '8px'
                                    }}>
                                        Quantity
                                    </div>
                                    <div style={{
                                        backgroundColor: '#f8f8f8',
                                        borderRadius: "2px",
                                        padding: '6px 12px',
                                        display: 'inline-block',
                                        minWidth: '80px',
                                        fontWeight: "bold",
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                    }}>
                                        <span style={{
                                            fontSize: '13px',
                                            fontWeight: 'bold',
                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                        }}>
                                            {user?.user?.[0]?.sponsorDetails?.[0]?.weight || 'N/A'} kg
                                        </span>
                                    </div>
                                </div>

                                {/* Date of Purchase */}
                                <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                    <div style={{
                                        margin: 0,
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        fontSize: '1rem',
                                        fontWeight: 400,
                                        letterSpacing: 0,
                                        lineHeight: '22px',
                                        color: '#282828',
                                        marginBottom: '8px'
                                    }}>
                                        Date of Purchase
                                    </div>
                                    <div style={{
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        backgroundColor: '#f8f8f8',
                                        borderRadius: "2px",
                                        padding: '6px 12px',
                                        display: 'inline-block',
                                        minWidth: '80px',
                                        fontWeight: "bold"
                                    }}>
                                        <span style={{
                                            fontSize: '13px',
                                            color: '#333',
                                            fontWeight: 'bold',
                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                        }}>
                                            {user?.user?.[0]?.sponsorDetails?.[0]?.date ?
                                                new Date(user?.user?.[0].sponsorDetails[0].date).toISOString().split('T')[0].replace(/-/g, '/')
                                                : 'N/A'
                                            }
                                        </span>
                                    </div>
                                </div>
                            </div>

                            {/* Signature Image */}
                            <div>
                                <h4 style={{ fontSize: '12px', fontWeight: '600', color: '#333', marginBottom: '10px' }}>
                                    Signature
                                </h4>
                                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                                    {user?.user?.[0]?.sponsorDetails?.[0]?.sign ? (
                                        <div style={{
                                            width: '80px',
                                            height: '80px',
                                            border: '1px solid #ddd',
                                            borderRadius: '6px',
                                            overflow: 'hidden'
                                        }}>
                                            <img
                                                src={user?.user?.[0]?.sponsorDetails?.[0]?.sign}
                                                alt="Sponsor Signature"
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover',
                                                    position: 'relative',
                                                    zIndex: 10,
                                                    cursor: 'pointer'
                                                }}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    window.open(user?.user?.[0]?.sponsorDetails?.[0]?.sign, '_blank');
                                                }}
                                            />
                                        </div>
                                    ) : (
                                        <div style={{ color: '#999', fontSize: '10px', padding: '10px' }}>
                                            No signature available
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div style={{
                        border: '1px solid #e0e0e0',
                        borderRadius: '8px',
                        backgroundColor: 'white',
                        boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                        overflow: 'hidden'
                    }}>
                        {/* Header */}
                        <div style={{
                            backgroundColor: '#e6f7f7',
                            padding: '12px 20px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            borderBottom: '1px solid #e0e0e0'
                        }}>
                            <h3 style={{
                                margin: 0,
                                fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                fontSize: '16px',
                                fontWeight: '600',
                                color: '#007a7d'
                            }}>
                                Audit Information
                            </h3>
                            <div style={{
                                width: '20px',
                                height: '20px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '14px',
                                fontWeight: 'bold',
                                transition: 'transform 0.3s ease',
                                color: '#007a7d'
                            }}>
                                ▼
                            </div>
                        </div>

                        {/* Content area */}
                        <div style={{ padding: '20px' }}>
                            {/* Flexible field container */}



                            {/* Add these after the Remarks field in Audit Information */}

                            {/* Standard */}

                            <div style={{
                                display: 'flex',
                                flexWrap: 'nowrap', // Change from 'wrap' to 'nowrap'
                                gap: '15px',
                                marginBottom: '20px',
                                overflowX: 'auto' // Add scroll if needed
                            }}>
                                <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                    <div style={{
                                        margin: 0,
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        fontSize: '1rem',
                                        fontWeight: 400,
                                        letterSpacing: 0,
                                        lineHeight: '22px',
                                        color: '#282828',
                                        marginBottom: '8px'
                                    }}>
                                        Standard
                                    </div>
                                    <div style={{
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        backgroundColor: '#f8f8f8',
                                        borderRadius: "2px",
                                        padding: '6px 12px',
                                        display: 'inline-block',
                                        minWidth: '80px',
                                        fontWeight: "bold"
                                    }}>
                                        <span style={{
                                            fontSize: '13px',
                                            color: '#333',
                                            fontWeight: "bold",
                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                        }}>
                                            {user?.auditStandard?.[0]?.auditName || 'N/A'}
                                        </span>
                                    </div>
                                </div>

                                {/* Governing Body */}
                                <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                    <div style={{
                                        margin: 0,
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        fontSize: '1rem',
                                        fontWeight: 400,
                                        letterSpacing: 0,
                                        lineHeight: '22px',
                                        color: '#282828',
                                        marginBottom: '8px'
                                    }}>
                                        Governing Body
                                    </div>
                                    <div style={{
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        backgroundColor: '#f8f8f8',
                                        borderRadius: "2px",
                                        padding: '6px 12px',
                                        display: 'inline-block',
                                        minWidth: '80px',
                                        fontWeight: "bold"
                                    }}>
                                        <span style={{
                                            fontSize: '13px',
                                            color: '#333',
                                            fontWeight: "bold",
                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                        }}>
                                            {user?.auditStandard?.[0]?.auditAuthorities || 'N/A'}
                                        </span>
                                    </div>
                                </div>

                                {/* Version Number */}
                                <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                    <div style={{
                                        margin: 0,
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        fontSize: '1rem',
                                        fontWeight: 400,
                                        letterSpacing: 0,
                                        lineHeight: '22px',
                                        color: '#282828',
                                        marginBottom: '8px'
                                    }}>
                                        Version Number
                                    </div>
                                    <div style={{
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        backgroundColor: '#f8f8f8',
                                        borderRadius: "2px",
                                        padding: '6px 12px',
                                        display: 'inline-block',
                                        minWidth: '80px',
                                        fontWeight: "bold"
                                    }}>
                                        <span style={{
                                            fontSize: '13px',
                                            color: '#333',
                                            fontWeight: "bold",
                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                        }}>
                                            {user?.auditStandard?.[0]?.versionNo || 'N/A'}
                                        </span>
                                    </div>
                                </div>

                                {/* Logo */}
                                <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                    <div style={{
                                        margin: 0,
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        fontSize: '1rem',
                                        fontWeight: 400,
                                        letterSpacing: 0,
                                        lineHeight: '22px',
                                        color: '#282828',
                                        marginBottom: '8px'
                                    }}>
                                        Logo
                                    </div>
                                    <div style={{
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        // backgroundColor: '#f8f8f8',
                                        borderRadius: "2px",
                                        padding: '6px 12px',
                                        display: 'inline-block',
                                        minWidth: '80px',
                                        fontWeight: "bold"
                                    }}>
                                        <img
                                            src={user?.auditStandard?.[0]?.logo}
                                            alt="Audit Standard Logo"
                                            style={{
                                                width: '40px',
                                                height: '40px',
                                                borderRadius: '50%',
                                                objectFit: 'cover',
                                                border: '2px solid #e5e7eb',
                                                cursor: 'pointer'
                                            }}
                                            onClick={() => window.open(user?.user?.[0]?.auditStandard?.[0]?.logo, '_blank')}
                                        // onError={(e) => {
                                        //     e.target.src = '/path/to/default-image.png'; // fallback image
                                        // }}
                                        />
                                    </div>
                                </div>
                            </div>


                            <div style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: '20px',
                                marginBottom: '20px'
                            }}>
                                {/* Auditor */}
                                <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                    <div style={{
                                        margin: 0,
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        fontSize: '1rem',
                                        fontWeight: 400,
                                        letterSpacing: 0,
                                        lineHeight: '22px',
                                        color: '#282828',
                                        marginBottom: '8px'
                                    }}>
                                        Auditor
                                    </div>
                                    <div style={{
                                        backgroundColor: '#f8f8f8',
                                        borderRadius: "2px",
                                        padding: '6px 12px',
                                        display: 'inline-block',
                                        minWidth: '80px',
                                        fontWeight: "bold"
                                    }}>
                                        <span style={{
                                            fontSize: '13px',
                                            color: '#333',
                                            fontWeight: 'bold',
                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                        }}>
                                            {user?.auditorInfo?.personalDetails?.name || 'N/A'}
                                        </span>
                                    </div>
                                </div>

                                {/* Company */}
                                <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                    <div style={{
                                        margin: 0,
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        fontSize: '1rem',
                                        fontWeight: 400,
                                        letterSpacing: 0,
                                        lineHeight: '22px',
                                        color: '#282828',
                                        marginBottom: '8px'
                                    }}>
                                        Company
                                    </div>
                                    <div style={{
                                        backgroundColor: '#f8f8f8',
                                        borderRadius: "2px",
                                        padding: '6px 12px',
                                        display: 'inline-block',
                                        minWidth: '80px',
                                        fontWeight: "bold",
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                    }}>
                                        <span style={{
                                            fontSize: '13px',
                                            // color: '#2563eb',
                                            fontWeight: 'bold',
                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                        }}>
                                            {user?.auditorInfo?.companyDetails?.name || 'N/A'}
                                        </span>
                                    </div>
                                </div>

                                {/* Date */}
                                <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                    <div style={{
                                        margin: 0,
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        fontSize: '1rem',
                                        fontWeight: 400,
                                        letterSpacing: 0,
                                        lineHeight: '22px',
                                        color: '#282828',
                                        marginBottom: '8px'
                                    }}>
                                        Date
                                    </div>
                                    <div style={{
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        backgroundColor: '#f8f8f8',
                                        borderRadius: "2px",
                                        padding: '6px 12px',
                                        display: 'inline-block',
                                        minWidth: '80px',
                                        fontWeight: "bold"
                                    }}>
                                        <span style={{
                                            fontSize: '13px',
                                            color: '#333',
                                            fontWeight: 'bold',
                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                        }}>
                                            {(() => {
                                                if (!user?.approvedAt) return 'N/A';

                                                const date = new Date(user.approvedAt);

                                                // Check if the date is valid
                                                if (isNaN(date.getTime())) return 'N/A';

                                                return date.toISOString().split('T')[0].replace(/-/g, '/');
                                            })()}
                                        </span>
                                    </div>
                                </div>

                                {/* Remarks */}
                                <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                    <div style={{
                                        margin: 0,
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        fontSize: '1rem',
                                        fontWeight: 400,
                                        letterSpacing: 0,
                                        lineHeight: '22px',
                                        color: '#282828',
                                        marginBottom: '8px'
                                    }}>
                                        Remarks
                                    </div>
                                    <div style={{
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        backgroundColor: '#f8f8f8',
                                        borderRadius: "2px",
                                        padding: '6px 12px',
                                        display: 'inline-block',
                                        minWidth: '80px',
                                        fontWeight: "bold"
                                    }}>
                                        <span style={{
                                            fontSize: '13px',
                                            color: '#333',
                                            fontWeight: "bold",
                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                        }}>
                                            {user?.user?.[0]?.remark || 'N/A'}
                                        </span>
                                    </div>


                                    {/* Add this after the Remarks field in Audit Information */}



                                </div>
                                <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                    <div style={{
                                        margin: 0,
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        fontSize: '1rem',
                                        fontWeight: 400,
                                        letterSpacing: 0,
                                        lineHeight: '22px',
                                        color: '#282828',
                                        marginBottom: '8px'
                                    }}>
                                        Logo
                                    </div>
                                    <div style={{
                                        fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                        // backgroundColor: '#f8f8f8',
                                        borderRadius: "2px",
                                        padding: '6px 12px',
                                        display: 'inline-block',
                                        minWidth: '80px',
                                        fontWeight: "bold"
                                    }}>
                                        {/* <img
                                        src={user?.user?.[0]?.auditorInfo?.kycDocument?.[0]?.docUrl}
                                        alt="KYC Document"
                                        style={{
                                            width: '40px',
                                            height: '40px',
                                            borderRadius: '50%',
                                            objectFit: 'cover',
                                            border: '2px solid #e5e7eb',
                                            cursor: 'pointer'  // Add cursor pointer to show it's clickable
                                        }}
                                        onClick={() => window.open(user?.user?.[0]?.auditorInfo?.kycDocument?.[0]?.docUrl, '_blank')}                                   
                                    /> */}



                                        <img
                                            src={user?.pickupPointInfo?.kycDocument?.find(doc => doc.docType === "POE")?.docUrl}
                                            alt="KYC Document - POE"
                                            style={{
                                                width: '40px',
                                                height: '40px',
                                                borderRadius: '50%',
                                                objectFit: 'cover',
                                                border: '2px solid #e5e7eb',
                                                cursor: 'pointer'
                                            }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                const poeDoc = user?.pickupPointInfo?.kycDocument?.find(doc => doc.docType === "POE");
                                                if (poeDoc?.docUrl) {
                                                    window.open(poeDoc.docUrl, '_blank');
                                                }
                                            }}
                                        />

                                    </div>
                                </div>
                            </div>

                            {/* Signature Image */}
                            <div>
                                <h4 style={{ fontSize: '12px', fontWeight: '600', color: '#333', marginBottom: '10px' }}>
                                    Signature
                                </h4>
                                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                                    {user?.user?.[0]?.sign ? (
                                        <div style={{
                                            width: '80px',
                                            height: '80px',
                                            border: '1px solid #ddd',
                                            borderRadius: '6px',
                                            overflow: 'hidden'
                                        }}>
                                            <img
                                                src={user?.user?.[0]?.sign}
                                                alt="Signature"
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover',
                                                    position: 'relative',
                                                    zIndex: 10,
                                                    cursor: 'pointer'
                                                }}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    window.open(user?.user?.[0]?.sign, '_blank');
                                                }}
                                            />
                                        </div>
                                    ) : (
                                        <div style={{ color: '#999', fontSize: '10px', padding: '10px' }}>
                                            No signature available
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>




                    <div style={{
                        border: '1px solid #e0e0e0',
                        borderRadius: '8px',
                        backgroundColor: 'white',
                        boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                        overflow: 'hidden',
                        marginBottom: "20px",
                        marginTop: "20px"
                    }}>
                        {/* Header */}
                        <div style={{
                            backgroundColor: '#e6f7f7',
                            padding: '12px 20px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            borderBottom: '1px solid #e0e0e0'
                        }}>
                            <h3 style={{
                                margin: 0,
                                fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                fontSize: '16px',
                                fontWeight: '600',
                                color: '#007a7d'
                            }}>
                                Supporting Documents
                            </h3>
                            <div style={{
                                width: '20px',
                                height: '20px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '14px',
                                fontWeight: 'bold',
                                transition: 'transform 0.3s ease',
                                color: '#007a7d'
                            }}>
                                ▼
                            </div>
                        </div>

                        {/* Content area */}
                        <div style={{ padding: '20px' }}>
                            {/* Images */}
                            <div>
                                <h4 style={{ fontSize: '12px', fontWeight: '600', color: '#333', marginBottom: '10px' }}>
                                    Documents
                                </h4>
                                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                                    {user?.images && user?.images.length > 0 ? (
                                        user?.images.map((imageUrl, imgIndex) => (
                                            <div key={imgIndex} style={{
                                                width: '100px',
                                                height: '100px',
                                                border: '1px solid #ddd',
                                                borderRadius: '6px',
                                                overflow: 'hidden'
                                            }}>
                                                <img
                                                    src={imageUrl}
                                                    alt={`Document ${imgIndex + 1}`}
                                                    style={{
                                                        width: '100%',
                                                        height: '100%',
                                                        objectFit: 'cover',
                                                        position: 'relative',
                                                        zIndex: 10,
                                                        cursor: 'pointer'
                                                    }}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        window.open(imageUrl, '_blank');
                                                    }}
                                                />
                                            </div>
                                        ))
                                    ) : (
                                        <div style={{ color: '#999', fontSize: '10px', padding: '10px' }}>
                                            No documents available
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>


                </div>


                {/* Chain of custody */}
                <div style={{ marginBottom: '1.5rem', marginTop: '1.5rem' }}>
                    <h2 style={{ fontSize: '1.125rem', fontWeight: 'bold', marginBottom: '0.75rem', color: 'black' }}>Chain of custody</h2>
                </div>


                <div className="chain-of-custody-wrapper">
                    <div className="custody-section">
                        <div className="" style={{ maxWidth: '1000px', margin: '0 auto', padding: '24px', backgroundColor: 'white' }}>
                            {user?.user?.[0]?.collectionDetails?.map((item, index) => {


                                return (
                                    <div key={index} className="chain-item" style={{ position: 'relative', marginBottom: '10px', backgroundColor: 'white' }}>
                                        {/* Main collection item */}
                                        <div style={{
                                            border: '1px solid #e0e0e0',
                                            borderRadius: '8px',
                                            backgroundColor: 'white',
                                            boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                                            marginLeft: '60px',
                                            overflow: 'hidden'
                                        }}>
                                            {/* Header with Details and expand/collapse arrow */}
                                            <div
                                                style={{
                                                    backgroundColor: '#e6f7f7',
                                                    padding: '12px 20px',
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    cursor: 'pointer',
                                                    borderBottom: '1px solid #e0e0e0'
                                                }}
                                            // onClick={() => toggleCard(index)}
                                            >
                                                <h3 style={{
                                                    margin: 0,
                                                    fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                    fontSize: '16px',
                                                    fontWeight: '600',
                                                    color: '#007a7d'
                                                }}>
                                                    {item.processName} Details
                                                </h3>
                                                <div style={{
                                                    width: '20px',
                                                    height: '20px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    // color: '#333',
                                                    fontSize: '14px',
                                                    fontWeight: 'bold',
                                                    // transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                                                    transition: 'transform 0.3s ease',
                                                    color: '#007a7d'
                                                }}>
                                                    ▼
                                                </div>
                                            </div>

                                            {/* Content area - conditionally rendered */}

                                            <div style={{ padding: '20px' }}>
                                                {/* Flexible field container */}
                                                <div style={{
                                                    display: 'flex',
                                                    flexWrap: 'wrap',
                                                    gap: '20px',
                                                    marginBottom: '20px'
                                                }}>
                                                    {/* Batch id */}
                                                    <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                                        <div style={{
                                                            margin: 0,
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                            fontSize: '1rem',
                                                            fontWeight: 400,
                                                            letterSpacing: 0,
                                                            lineHeight: '22px',
                                                            color: '#282828',
                                                            marginBottom: '8px'
                                                        }}>
                                                            Batch id
                                                        </div>
                                                        <div style={{
                                                            backgroundColor: '#f8f8f8',
                                                            borderRadius: "2px",
                                                            padding: '6px 12px',
                                                            display: 'inline-block',
                                                            minWidth: '80px',
                                                            fontWeight: "bold"
                                                        }}>
                                                            <span style={{
                                                                fontSize: '13px',
                                                                color: '#333',
                                                                fontWeight: 'bold',
                                                                fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                                            }}>
                                                                {item.batchId || 'N/A'}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    {/* Weight */}
                                                    <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                                        <div style={{
                                                            margin: 0,
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                            fontSize: '1rem',
                                                            fontWeight: 400,
                                                            letterSpacing: 0,
                                                            lineHeight: '22px',
                                                            color: '#282828',
                                                            marginBottom: '8px'
                                                        }}>
                                                            Weight
                                                        </div>
                                                        <div style={{
                                                            backgroundColor: '#f8f8f8',
                                                            borderRadius: "2px",
                                                            padding: '6px 12px',
                                                            display: 'inline-block',
                                                            minWidth: '80px',
                                                            fontWeight: "bold",
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                        }}>
                                                            <span style={{
                                                                fontSize: '13px',
                                                                color: '#333',
                                                                fontWeight: 'bold',
                                                                fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                                            }}>
                                                                {item.usedQuantity} kg
                                                            </span>
                                                        </div>
                                                    </div>

                                                    {/* Process */}
                                                    <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                                        <div style={{
                                                            margin: 0,
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                            fontSize: '1rem',
                                                            fontWeight: 400,
                                                            letterSpacing: 0,
                                                            lineHeight: '22px',
                                                            color: '#282828',
                                                            marginBottom: '8px'
                                                        }}>
                                                            Process
                                                        </div>
                                                        <div style={{
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                            backgroundColor: '#f8f8f8',
                                                            borderRadius: "2px",
                                                            padding: '6px 12px',
                                                            display: 'inline-block',
                                                            minWidth: '80px',
                                                            fontWeight: "bold"
                                                        }}>
                                                            <span style={{
                                                                fontSize: '13px',
                                                                color: '#333',
                                                                fontWeight: 'bold',
                                                                fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                                            }}>
                                                                {item.processName}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    {/* Input */}
                                                    <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                                        <div style={{
                                                            margin: 0,
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                            fontSize: '1rem',
                                                            fontWeight: 400,
                                                            letterSpacing: 0,
                                                            lineHeight: '22px',
                                                            color: '#282828',
                                                            marginBottom: '8px'
                                                        }}>
                                                            Category
                                                        </div>
                                                        <div style={{
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                            backgroundColor: '#f8f8f8',
                                                            borderRadius: "2px",
                                                            padding: '6px 12px',
                                                            display: 'inline-block',
                                                            minWidth: '80px',
                                                            fontWeight: "bold"
                                                        }}>
                                                            <span style={{
                                                                fontSize: '13px',
                                                                color: '#333',
                                                                fontWeight: "bold",
                                                                fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                                            }}>
                                                                {item.categoryName ?? 'N/A'}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    {/* Item */}
                                                    <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                                        <div style={{
                                                            margin: 0,
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                            fontSize: '1rem',
                                                            fontWeight: 400,
                                                            letterSpacing: 0,
                                                            lineHeight: '22px',
                                                            color: '#282828',
                                                            marginBottom: '8px'
                                                        }}>
                                                            Item
                                                        </div>
                                                        <div style={{
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                            backgroundColor: '#f8f8f8',
                                                            borderRadius: "2px",
                                                            padding: '6px 12px',
                                                            display: 'inline-block',
                                                            minWidth: '80px',
                                                            fontWeight: "bold"
                                                        }}>
                                                            <span style={{
                                                                fontSize: '13px',
                                                                color: '#333',
                                                                fontWeight: "bold",
                                                                fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                                            }}>
                                                                {item.itemName || 'N/A'}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    {/* Site */}
                                                    <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                                        <div style={{
                                                            margin: 0,
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                            fontSize: '1rem',
                                                            fontWeight: 400,
                                                            letterSpacing: 0,
                                                            lineHeight: '22px',
                                                            color: '#282828',
                                                            marginBottom: '8px'
                                                        }}>
                                                            Site
                                                        </div>
                                                        <div style={{
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                            backgroundColor: '#f8f8f8',
                                                            borderRadius: "2px",
                                                            padding: '6px 12px',
                                                            display: 'inline-block',
                                                            minWidth: '80px',
                                                            fontWeight: "bold"
                                                        }}>
                                                            <span style={{
                                                                fontSize: '13px',
                                                                color: '#333',
                                                                fontWeight: "bold",
                                                                fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                                            }}>
                                                                {item.pickupPointName || 'N/A'}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    {/* Source */}
                                                    <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                                        <div style={{
                                                            margin: 0,
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                            fontSize: '1rem',
                                                            fontWeight: 400,
                                                            letterSpacing: 0,
                                                            lineHeight: '22px',
                                                            color: '#282828',
                                                            marginBottom: '8px'
                                                        }}>
                                                            Source
                                                        </div>
                                                        <div style={{
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                            backgroundColor: '#f8f8f8',
                                                            borderRadius: "2px",
                                                            padding: '6px 12px',
                                                            display: 'inline-block',
                                                            minWidth: '80px',
                                                            fontWeight: "bold"
                                                        }}>
                                                            <span style={{
                                                                fontSize: '13px',
                                                                color: '#333',
                                                                fontWeight: "bold",
                                                                fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                                            }}>
                                                                {item.sourceName || 'N/A'}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    {/* Address */}
                                                    <div style={{ flex: '0 0 auto', width: 'auto' }}>
                                                        <div style={{
                                                            margin: 0,
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                            fontSize: '1rem',
                                                            fontWeight: 400,
                                                            letterSpacing: 0,
                                                            lineHeight: '22px',
                                                            color: '#282828',
                                                            marginBottom: '8px'
                                                        }}>
                                                            Address
                                                        </div>
                                                        <div style={{
                                                            backgroundColor: '#f8f8f8',
                                                            borderRadius: "2px",
                                                            padding: '6px 12px',
                                                            display: 'inline-block',
                                                            minWidth: '80px',
                                                            fontWeight: "bold",
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                                        }}>
                                                            <span style={{ fontSize: '13px', color: '#333' }}>
                                                                {item.sourceAddress || 'N/A'}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    {/* Country */}
                                                    <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                                        <div style={{
                                                            margin: 0,
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                            fontSize: '1rem',
                                                            fontWeight: 400,
                                                            letterSpacing: 0,
                                                            lineHeight: '22px',
                                                            color: '#282828',
                                                            marginBottom: '8px'
                                                        }}>
                                                            Country
                                                        </div>
                                                        <div style={{
                                                            backgroundColor: '#f8f8f8',
                                                            borderRadius: "2px",
                                                            padding: '6px 12px',
                                                            display: 'inline-block',
                                                            minWidth: '80px',
                                                            fontWeight: "bold",
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                                        }}>
                                                            <span style={{
                                                                fontSize: '13px',
                                                                color: '#333',
                                                                fontWeight: "bold",
                                                                fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                                            }}>
                                                                {item.country || 'N/A'}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Production Images */}
                                                <div>
                                                    <h4 style={{ fontSize: '12px', fontWeight: '600', color: '#333', marginBottom: '10px' }}>
                                                        Images
                                                    </h4>
                                                    <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                                                        {item.images && item.images.length > 0 ? (
                                                            item.images.map((imageUrl, imgIndex) => (
                                                                <div key={imgIndex} style={{
                                                                    width: '80px',
                                                                    height: '80px',
                                                                    border: '1px solid #ddd',
                                                                    borderRadius: '6px',
                                                                    overflow: 'hidden'
                                                                }}>
                                                                    <img
                                                                        src={imageUrl}
                                                                        alt={`Production ${imgIndex + 1}`}
                                                                        style={{
                                                                            width: '100%',
                                                                            height: '100%',
                                                                            objectFit: 'cover',
                                                                            position: 'relative',
                                                                            zIndex: 10,
                                                                            cursor: 'pointer'
                                                                        }}
                                                                        onClick={() => window.open(imageUrl, '_blank')}
                                                                    />
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <div style={{ color: '#999', fontSize: '10px', padding: '10px' }}>
                                                                No images available
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                        </div>


                                        {/* Date display - shown for all containers */}
                                        <div className="timeline-line" style={{
                                            position: 'absolute',
                                            left: '40px',
                                            top: '0px',
                                            bottom: '-10px',
                                            width: '2px',
                                            backgroundColor: '#007a7d',
                                            zIndex: 1
                                        }}></div>
                                        <div style={{
                                            position: 'absolute',
                                            left: '34px',
                                            top: '25px',
                                            width: '14px',
                                            height: '14px',
                                            borderRadius: '50%',
                                            backgroundColor: '#007a7d',
                                            border: '3px solid white',
                                            zIndex: 2
                                        }}></div>


                                        <div style={{
                                            position: 'absolute',
                                            left: '-40px',
                                            top: '20px',
                                            fontSize: '11px',
                                            fontWeight: 'bold',
                                            color: '#333',
                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                            whiteSpace: 'nowrap',
                                            padding: '4px 8px',
                                            // backgroundColor: 'white',
                                            // border: '1px solid #ddd',
                                            // borderRadius: '4px',
                                            // boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                                        }}>
                                            <div style={{ whiteSpace: 'pre-line' }}>
                                                {`${new Date(item.date).getFullYear()}/${String(new Date(item.date).getMonth() + 1).padStart(2, '0')}/${String(new Date(item.date).getDate()).padStart(2, '0')}\n${new Date(item.date).toLocaleTimeString('en-GB', {
                                                    hour: '2-digit',
                                                    minute: '2-digit',
                                                    hour12: false
                                                })}`}
                                            </div>

                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    <div className="process-section">
                        <div className="" style={{ maxWidth: '1000px', margin: '0 auto', padding: '24px', backgroundColor: 'white' }}>
                            {user?.user?.[0]?.processDetails?.map((item, index) => {


                                return (
                                    <div key={index} className="chain-item" style={{ position: 'relative', marginBottom: '10px', backgroundColor: 'white' }}>
                                        {/* Main collection item */}
                                        <div style={{
                                            border: '1px solid #e0e0e0',
                                            borderRadius: '8px',
                                            backgroundColor: 'white',
                                            boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                                            marginLeft: '60px',
                                            overflow: 'hidden'
                                        }}>
                                            {/* Header with Details and expand/collapse arrow */}
                                            <div
                                                style={{
                                                    backgroundColor: '#e6f7f7',
                                                    padding: '12px 20px',
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    cursor: 'pointer',
                                                    borderBottom: '1px solid #e0e0e0'
                                                }}
                                            // onClick={() => toggleCard(index)}
                                            >
                                                <h3 style={{
                                                    margin: 0,
                                                    fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                    fontSize: '16px',
                                                    fontWeight: '600',
                                                    color: '#007a7d'
                                                }}>
                                                    {item.processName} Details
                                                </h3>
                                                <div style={{
                                                    width: '20px',
                                                    height: '20px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    // color: '#333',
                                                    fontSize: '14px',
                                                    fontWeight: 'bold',
                                                    // transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                                                    transition: 'transform 0.3s ease',
                                                    color: '#007a7d'
                                                }}>
                                                    ▼
                                                </div>
                                            </div>

                                            {/* Content area - conditionally rendered */}

                                            <div style={{ padding: '20px' }}>
                                                {/* Flexible field container */}
                                                <div style={{
                                                    display: 'flex',
                                                    flexWrap: 'wrap',
                                                    gap: '20px',
                                                    marginBottom: '20px'
                                                }}>
                                                    {/* Batch id */}
                                                    <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                                        <div style={{
                                                            margin: 0,
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                            fontSize: '1rem',
                                                            fontWeight: 400,
                                                            letterSpacing: 0,
                                                            lineHeight: '22px',
                                                            color: '#282828',
                                                            marginBottom: '8px'
                                                        }}>
                                                            Batch id
                                                        </div>
                                                        <div style={{
                                                            backgroundColor: '#f8f8f8',
                                                            borderRadius: "2px",
                                                            padding: '6px 12px',
                                                            display: 'inline-block',
                                                            minWidth: '80px',
                                                            fontWeight: "bold"
                                                        }}>
                                                            <span style={{
                                                                fontSize: '13px',
                                                                color: '#333',
                                                                fontWeight: 'bold',
                                                                fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                                            }}>
                                                                {item.batchId || 'N/A'}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    {/* Weight */}
                                                    <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                                        <div style={{
                                                            margin: 0,
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                            fontSize: '1rem',
                                                            fontWeight: 400,
                                                            letterSpacing: 0,
                                                            lineHeight: '22px',
                                                            color: '#282828',
                                                            marginBottom: '8px'
                                                        }}>
                                                            Weight
                                                        </div>
                                                        <div style={{
                                                            backgroundColor: '#f8f8f8',
                                                            borderRadius: "2px",
                                                            padding: '6px 12px',
                                                            display: 'inline-block',
                                                            minWidth: '80px',
                                                            fontWeight: "bold",
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                        }}>
                                                            <span style={{
                                                                fontSize: '13px',
                                                                color: '#333',
                                                                fontWeight: 'bold',
                                                                fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                                            }}>
                                                                {item.usedQuantity} kg
                                                            </span>
                                                        </div>
                                                    </div>

                                                    {/* Process */}
                                                    <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                                        <div style={{
                                                            margin: 0,
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                            fontSize: '1rem',
                                                            fontWeight: 400,
                                                            letterSpacing: 0,
                                                            lineHeight: '22px',
                                                            color: '#282828',
                                                            marginBottom: '8px'
                                                        }}>
                                                            Process
                                                        </div>
                                                        <div style={{
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                            backgroundColor: '#f8f8f8',
                                                            borderRadius: "2px",
                                                            padding: '6px 12px',
                                                            display: 'inline-block',
                                                            minWidth: '80px',
                                                            fontWeight: "bold"
                                                        }}>
                                                            <span style={{
                                                                fontSize: '13px',
                                                                color: '#333',
                                                                fontWeight: 'bold',
                                                                fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                                            }}>
                                                                {item.processName}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    {/* Input */}
                                                    <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                                        <div style={{
                                                            margin: 0,
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                            fontSize: '1rem',
                                                            fontWeight: 400,
                                                            letterSpacing: 0,
                                                            lineHeight: '22px',
                                                            color: '#282828',
                                                            marginBottom: '8px'
                                                        }}>
                                                            Category
                                                        </div>
                                                        <div style={{
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                            backgroundColor: '#f8f8f8',
                                                            borderRadius: "2px",
                                                            padding: '6px 12px',
                                                            display: 'inline-block',
                                                            minWidth: '80px',
                                                            fontWeight: "bold"
                                                        }}>
                                                            <span style={{
                                                                fontSize: '13px',
                                                                color: '#333',
                                                                fontWeight: "bold",
                                                                fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                                            }}>
                                                                {item.categoryName ?? 'N/A'}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    {/* Item */}
                                                    <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                                        <div style={{
                                                            margin: 0,
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                            fontSize: '1rem',
                                                            fontWeight: 400,
                                                            letterSpacing: 0,
                                                            lineHeight: '22px',
                                                            color: '#282828',
                                                            marginBottom: '8px'
                                                        }}>
                                                            Item
                                                        </div>
                                                        <div style={{
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                            backgroundColor: '#f8f8f8',
                                                            borderRadius: "2px",
                                                            padding: '6px 12px',
                                                            display: 'inline-block',
                                                            minWidth: '80px',
                                                            fontWeight: "bold"
                                                        }}>
                                                            <span style={{
                                                                fontSize: '13px',
                                                                color: '#333',
                                                                fontWeight: "bold",
                                                                fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                                            }}>
                                                                {item.itemName || 'N/A'}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    {/* Site */}
                                                    <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                                        <div style={{
                                                            margin: 0,
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                            fontSize: '1rem',
                                                            fontWeight: 400,
                                                            letterSpacing: 0,
                                                            lineHeight: '22px',
                                                            color: '#282828',
                                                            marginBottom: '8px'
                                                        }}>
                                                            Site
                                                        </div>
                                                        <div style={{
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                            backgroundColor: '#f8f8f8',
                                                            borderRadius: "2px",
                                                            padding: '6px 12px',
                                                            display: 'inline-block',
                                                            minWidth: '80px',
                                                            fontWeight: "bold"
                                                        }}>
                                                            <span style={{
                                                                fontSize: '13px',
                                                                color: '#333',
                                                                fontWeight: "bold",
                                                                fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                                            }}>
                                                                {item.pickupPointName || 'N/A'}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    {/* Source */}
                                                    <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                                        <div style={{
                                                            margin: 0,
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                            fontSize: '1rem',
                                                            fontWeight: 400,
                                                            letterSpacing: 0,
                                                            lineHeight: '22px',
                                                            color: '#282828',
                                                            marginBottom: '8px'
                                                        }}>
                                                            Source
                                                        </div>
                                                        <div style={{
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                            backgroundColor: '#f8f8f8',
                                                            borderRadius: "2px",
                                                            padding: '6px 12px',
                                                            display: 'inline-block',
                                                            minWidth: '80px',
                                                            fontWeight: "bold"
                                                        }}>
                                                            <span style={{
                                                                fontSize: '13px',
                                                                color: '#333',
                                                                fontWeight: "bold",
                                                                fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                                            }}>
                                                                {item.sourceName || 'N/A'}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    {/* Address */}
                                                    <div style={{ flex: '0 0 auto', width: 'auto' }}>
                                                        <div style={{
                                                            margin: 0,
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                            fontSize: '1rem',
                                                            fontWeight: 400,
                                                            letterSpacing: 0,
                                                            lineHeight: '22px',
                                                            color: '#282828',
                                                            marginBottom: '8px'
                                                        }}>
                                                            Address
                                                        </div>
                                                        <div style={{
                                                            backgroundColor: '#f8f8f8',
                                                            borderRadius: "2px",
                                                            padding: '6px 12px',
                                                            display: 'inline-block',
                                                            minWidth: '80px',
                                                            fontWeight: "bold",
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                                        }}>
                                                            <span style={{ fontSize: '13px', color: '#333' }}>
                                                                {item.sourceAddress || 'N/A'}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    {/* Country */}
                                                    <div style={{ flex: '0 0 auto', minWidth: 'auto' }}>
                                                        <div style={{
                                                            margin: 0,
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                                            fontSize: '1rem',
                                                            fontWeight: 400,
                                                            letterSpacing: 0,
                                                            lineHeight: '22px',
                                                            color: '#282828',
                                                            marginBottom: '8px'
                                                        }}>
                                                            Country
                                                        </div>
                                                        <div style={{
                                                            backgroundColor: '#f8f8f8',
                                                            borderRadius: "2px",
                                                            padding: '6px 12px',
                                                            display: 'inline-block',
                                                            minWidth: '80px',
                                                            fontWeight: "bold",
                                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                                        }}>
                                                            <span style={{
                                                                fontSize: '13px',
                                                                color: '#333',
                                                                fontWeight: "bold",
                                                                fontFamily: "'Roboto', 'Roboto Fallback', sans-serif"
                                                            }}>
                                                                {item.country || 'N/A'}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Production Images */}
                                                <div>
                                                    <h4 style={{ fontSize: '12px', fontWeight: '600', color: '#333', marginBottom: '10px' }}>
                                                        Images
                                                    </h4>
                                                    <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                                                        {item.images && item.images.length > 0 ? (
                                                            item.images.map((imageUrl, imgIndex) => (
                                                                <div key={imgIndex} style={{
                                                                    width: '80px',
                                                                    height: '80px',
                                                                    border: '1px solid #ddd',
                                                                    borderRadius: '6px',
                                                                    overflow: 'hidden'
                                                                }}>
                                                                    <img
                                                                        src={imageUrl}
                                                                        alt={`Production ${imgIndex + 1}`}
                                                                        style={{
                                                                            width: '100%',
                                                                            height: '100%',
                                                                            objectFit: 'cover',
                                                                            position: 'relative',
                                                                            zIndex: 10,
                                                                            cursor: 'pointer'
                                                                        }}
                                                                        onClick={() => window.open(imageUrl, '_blank')}
                                                                    />
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <div style={{ color: '#999', fontSize: '10px', padding: '10px' }}>
                                                                No images available
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                        </div>


                                        {/* Date display - shown for all containers */}
                                        <div className="timeline-line" style={{
                                            position: 'absolute',
                                            left: '40px',
                                            top: '0px',
                                            bottom: '-10px',
                                            width: '2px',
                                            backgroundColor: '#007a7d',
                                            zIndex: 1
                                        }}></div>
                                        <div style={{
                                            position: 'absolute',
                                            left: '34px',
                                            top: '25px',
                                            width: '14px',
                                            height: '14px',
                                            borderRadius: '50%',
                                            backgroundColor: '#007a7d',
                                            border: '3px solid white',
                                            zIndex: 2
                                        }}></div>


                                        <div style={{
                                            position: 'absolute',
                                            left: '-40px',
                                            top: '20px',
                                            fontSize: '11px',
                                            fontWeight: 'bold',
                                            color: '#333',
                                            fontFamily: "'Roboto', 'Roboto Fallback', sans-serif",
                                            whiteSpace: 'nowrap',
                                            padding: '4px 8px',
                                            // backgroundColor: 'white',
                                            // border: '1px solid #ddd',
                                            // borderRadius: '4px',
                                            // boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                                        }}>
                                            <div style={{ whiteSpace: 'pre-line' }}>
                                                {`${new Date(item.date).getFullYear()}/${String(new Date(item.date).getMonth() + 1).padStart(2, '0')}/${String(new Date(item.date).getDate()).padStart(2, '0')}\n${new Date(item.date).toLocaleTimeString('en-GB', {
                                                    hour: '2-digit',
                                                    minute: '2-digit',
                                                    hour12: false
                                                })}`}
                                            </div>

                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>


                <img
                    src="/footer.png"
                    alt="background"
                    style={{
                        width: '100%',
                        height: '100%'
                    }}
                />


            </div>
        </>
    );
};

export default ProductionReceipt1;